
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users, Target, TrendingUp } from 'lucide-react';

const JobsHero = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-brand-lightBlue via-white to-brand-gray">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Werk bij <span className="text-brand-blue">Afsprakenmaker</span>
          </h1>
          
          <p className="text-xl text-gray-700 mb-8 leading-relaxed">
            Een jong en dynamisch bedrijf gespecialiseerd in kwalitatieve pre-sales en salesprocessen
          </p>
          
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <Target className="h-12 w-12 text-brand-blue mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Meer dan afspraken maken</h3>
              <p className="text-gray-600">We zorgen ervoor dat elke prospect grondig wordt gekwalificeerd</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <Users className="h-12 w-12 text-brand-blue mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Vertrouwen & autonomie</h3>
              <p className="text-gray-600">We geloven in vertrouwen, autonomie en collegialiteit</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100">
              <TrendingUp className="h-12 w-12 text-brand-blue mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Groeikansen</h3>
              <p className="text-gray-600">Ons open office space biedt kansen om te groeien en door te stromen</p>
            </div>
          </div>
          
          <Button 
            size="lg" 
            className="bg-brand-red hover:bg-brand-red/90 text-white"
            onClick={() => document.getElementById('job-application')?.scrollIntoView({ behavior: 'smooth' })}
          >
            Bekijk onze vacatures
          </Button>
        </div>
      </div>
    </section>
  );
};

export default JobsHero;
